import React from 'react';
import PropTypes from 'prop-types';
import { PsListTable } from '../../../shared/components/list-table/PsListTable';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import { ActiveBadge } from '../../../shared/components/ActiveLabel';
import RouterUtils from '../../../shared/routing/RouterUtils';
import { PsRoutes } from '../../../shared/routing/Routes';
import LinkButton from '../../../shared/components/LinkButton';
import _ from 'lodash';
import OutsourceChart from '../../../outsource/components/OutsourceChart';
import './OutsourceListTable.css';

export class OutsourceListTable extends React.Component {

    render() {
        const {
            data,
            error,
            loading,
        } = this.props;

        return (
            <PsListTable
                data={data}
                error={error}
                loading={loading}
                headings={(
                    <tr>
                        <th/>
                        <th>{I18nUtils.tr('TR_NOMBRE')}</th>
                        <th>{I18nUtils.tr('TR_ESTADO')}</th>
                        <th>{I18nUtils.tr('TR_CIF')}</th>
                        <th>{I18nUtils.tr('TR_ESQUEMA_DOCUMENTACION')}</th>
                        <th>{I18nUtils.tr('TR_ESQUEMA_MENSUAL')}</th>
                        <th>{I18nUtils.tr('TR_EMAIL')}</th>
                        <th/>
                    </tr>
                )}
            >
                {
                    _.map(data, (outsource, index) => {
                        return (
                            <tr key={index}>
                                <td className={'chart-wrap-item-table'}>
                                    <OutsourceChart stats={outsource.document_stats}/>
                                </td>
                                <td>{outsource.name ? outsource.name : ''}</td>
                                <td><ActiveBadge active={!outsource.disabled}/></td>
                                <td>{outsource.nif ? outsource.nif : ''}</td>
                                <td>{outsource.document_schema && outsource.document_schema.name ? outsource.document_schema.name : ''}</td>
                                <td>{outsource.document_schema_monthly && outsource.document_schema_monthly.name ? outsource.document_schema_monthly.name : ''}</td>
                                <td>{outsource.email ? outsource.email : ''}</td>
                                <td>
                                    <LinkButton
                                        to={RouterUtils.generateRoute(PsRoutes.MY_OUTSOURCES_DETAIL, { id: outsource.id })}
                                        text={I18nUtils.tr('TR_VER_FICHA')}
                                        className={'btn-sm'}
                                    />
                                </td>
                            </tr>
                        );
                    })
                }
            </PsListTable>
        );
    }
}

OutsourceListTable.propTypes = {
    data: PropTypes.array,
    error: PropTypes.string,
    loading: PropTypes.bool,
};

OutsourceListTable.defaultProps = {
    data: [],
    error: '',
};




// WEBPACK FOOTER //
// ./src/app/my-outsources/outsource/list/OutsourceListTable.jsx